import {SimStats, SimStatsInstance} from "./SimStats";
import {SimRunes} from "./CalculationObjects";
import {RiotChampStats, default as RiotDB} from "../RiotDB";
import SimPlayer from "./SimPlayer";
import {SimSkillOrder} from "./SkillOrder";
import SimChampion from "./SimChampion";
import {AbilityInfo} from "./AbilityInfo";
import DamageInfo from "./DamageInfo";
import {ComboInfo} from "../ComboInfo";
import Player from "../Player";

export interface UIComboDamageInfo {
	enemyChampName:string;
	damageNumber:number;
	percentHealth:number;
	manaSpent:number;
	percentMana:number;
}


export function createSimPlayer(level, riotName, runes:SimRunes, skillOrder:SimSkillOrder){
	return new SimPlayer(level, new SimChampion(RiotDB.getChampionJSON(riotName).stats), skillOrder, runes);
}

export class Calculation{
	static me:SimPlayer;
	static them:SimPlayer;

	static addItemsToSimPlayer(simPlayer, items){
		for (let i = 0; i < items.length; i++) {
			let item = items[i];
			let level = simPlayer.getInfo().level;
			if (item.level <= level) {
				simPlayer.addItem(RiotDB.getItemByName(item.itemName))
			}
		}
		return simPlayer
	}

	static calculatePlayerComboDamage(source:Player, target:Player, combo:ComboInfo, level:number):UIComboDamageInfo{

		//TODO deal with players who are different levels

		let sourceSimPlayer:SimPlayer = SimPlayer.createFromPlayer(source,level);
		let targetSimPlayer:SimPlayer = SimPlayer.createFromPlayer(target, level);

		sourceSimPlayer = Calculation.addItemsToSimPlayer(sourceSimPlayer, source.selectedItems);
		targetSimPlayer = Calculation.addItemsToSimPlayer(targetSimPlayer, target.selectedItems);

		let damageInfo = Calculation.calculateComboDamageDone(sourceSimPlayer, targetSimPlayer,combo);
		let damageNumber = damageInfo.getTotalDamage();
		let percentHealth = Math.round((damageNumber/targetSimPlayer.getInfo().H)*100)/100;
		let percentMana = Math.round((damageInfo.manaSpent / targetSimPlayer.getInfo().MA)*100)/100;

		return {
			enemyChampName:target.selectedChampion,
			damageNumber,
			percentHealth,
			manaSpent:damageInfo.manaSpent,
			percentMana
		}
	}

	static calculatePlayerAbilityDamage(source:Player, target:Player, sourceAbility:AbilityInfo, level:number):DamageInfo{
		let sourceSimPlayer:SimPlayer = SimPlayer.createFromPlayer(source,level);
		let targetSimPlayer:SimPlayer = SimPlayer.createFromPlayer(target, level);
		sourceSimPlayer = Calculation.addItemsToSimPlayer(sourceSimPlayer, source.selectedItems);
		targetSimPlayer = Calculation.addItemsToSimPlayer(targetSimPlayer, target.selectedItems);

		return Calculation.calculateAbilityDamageDone(sourceSimPlayer, targetSimPlayer, sourceAbility);

	}

	static calculateAbilityDamageDone(source:SimPlayer,target:SimPlayer,sourceAbility:AbilityInfo){

		let sourceInfo = source.getInfo();
		let targetInfo = target.getInfo();
		let rawDI = Calculation.calculateRawAbilityDamage(source,sourceAbility, target);
		let di = new DamageInfo();


		//TODO calculate lethality
		let theirEffectiveArmor = targetInfo.A;
		let adDamageMultiplier = 0;

		if(theirEffectiveArmor > 0){
			adDamageMultiplier = 100 / (100 + theirEffectiveArmor);
		}

		let adDamageReduction = (1-adDamageMultiplier);
		di.adDamage = rawDI.adDamage * adDamageMultiplier;


		let theirEffectiveMR = targetInfo.MR - sourceInfo.MP;
		let apDamageMultiplier;
		if(theirEffectiveMR > 0){
			apDamageMultiplier = 100 / (100 + theirEffectiveMR);
		}else{
			apDamageMultiplier = 2- (100/(100-theirEffectiveMR));
		}
		let apDamageReduction = 1-apDamageMultiplier;

		di.apDamage = rawDI.apDamage * apDamageMultiplier;
		di.trueDamage = rawDI.trueDamage;
		di.manaSpent = rawDI.manaSpent;
		di.rank = rawDI.rank;

		return di;

	}

	static calculateComboDamageDone(source:SimPlayer, target:SimPlayer, combo:ComboInfo):DamageInfo{
		let abilities = combo.abilities;
		let di = new DamageInfo();
		for (let i = 0; i < abilities.length; i++) {
			let ability = abilities[i];
			let abilityDamage = this.calculateAbilityDamageDone(source, target, ability);
			di.add(abilityDamage);
		}

		return di;
	}

	static calculateRawAbilityDamage(play:SimPlayer, ability:AbilityInfo, target?:SimPlayer):DamageInfo{
		let ret = new DamageInfo();

		//First figure out the rank
		let order = play.skillOrder;

		let rank = 0;
		if(ability.key != undefined){
			rank = play.getRankForAbility(ability.key);
		}

		let me:any = play.getInfo();
		let them:any;

		if (target != undefined){
			them = target.getInfo();
		}

		let r = function(base,rankInterval){
			return base + ((rank-1) * rankInterval);
		};

		let ap = function(ratio){
			return me.AP * ratio;
		};

		let ad = function(ratio){
			return me.AD * ratio;
		};

		let lvl = function(base, lvlInterval){
			return base + ((me.level-1) * lvlInterval);
		};

		ret.adDamage = eval(ability.adDamageCalc);
		ret.apDamage = eval(ability.apDamageCalc);
		ret.trueDamage = eval(ability.trueDamageCalc);
		ret.manaSpent = eval(ability.manaUsedCalc);
		ret.rank = rank;

		return ret;

	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/calculation/Calculation.ts